import { fetchCachedPublicGet } from "./publicRequest";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  );
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const fetchCruiseFeed = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/cruises/feed${buildQuery(params)}`, options);

export const fetchCruiseDetail = (destinationSlug, cruiseSlug, options = {}) => {
  if (!destinationSlug || !cruiseSlug) {
    return Promise.reject(new Error("Destination or cruise slug missing"));
  }
  const requestOptions = { ...options };
  const path = `/explore/cruises/${destinationSlug}/${cruiseSlug}${buildQuery({ view: options.view })}`;
  delete requestOptions.view;
  return fetchCachedPublicGet(path, requestOptions);
};
